import axios from "axios";

export default async function deleteProject(projectName, {username, password}){
    await axios.post(`/project/${projectName}/confirm-user-credentials`, {username, password})
}